import styled from 'styled-components';

const InvitationsShowStyles = styled.div``;

export default InvitationsShowStyles;
